var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { validateEmail, validatePassword } from "@/utils/loginValidation";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useAuth } from "@/context/AuthContext";
import { MdError } from "react-icons/md";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./LoginPage.css";
const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuth, login, error: authError } = useAuth();
    const locationState = location.state;
    const fromPath = (locationState === null || locationState === void 0 ? void 0 : locationState.from)
        ? `${locationState.from.pathname || ""}${locationState.from.search || ""}`
        : "/";
    useEffect(() => {
        if (isAuth) {
            navigate(fromPath, { replace: true });
        }
    }, [fromPath, isAuth, navigate]);
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [errors, setErrors] = useState({
        email: "",
        password: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => (Object.assign(Object.assign({}, prev), { [name]: value })));
        if (name === "email") {
            setErrors((prev) => (Object.assign(Object.assign({}, prev), { email: validateEmail(value) })));
        }
        else if (name === "password") {
            setErrors((prev) => (Object.assign(Object.assign({}, prev), { password: validatePassword(value) })));
        }
    };
    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (name === "email") {
            setErrors((prev) => (Object.assign(Object.assign({}, prev), { email: validateEmail(value) })));
        }
        else if (name === "password") {
            setErrors((prev) => (Object.assign(Object.assign({}, prev), { password: validatePassword(value) })));
        }
    };
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        const emailError = validateEmail(formData.email);
        const passwordError = validatePassword(formData.password);
        if (emailError || passwordError) {
            setErrors({
                email: emailError,
                password: passwordError,
            });
            return;
        }
        try {
            yield login(formData.email, formData.password, {
                preventRedirect: true,
            });
            navigate(fromPath, { replace: true });
        }
        catch (err) {
            console.log(err);
        }
    });
    return (_jsx("div", { className: "login-wrapper", children: _jsx("div", { className: "login-container", children: _jsxs("div", { className: "login-card", children: [_jsx("h1", { className: "login-title", children: "Welcome!" }), _jsx("p", { className: "login-subtitle", children: "Please enter your credentials" }), _jsxs("form", { onSubmit: handleSubmit, className: "login-form", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "email", children: "Email" }), _jsxs("div", { className: "input-wrapper", children: [_jsx("input", { type: "email", id: "email", name: "email", value: formData.email, onChange: handleChange, onBlur: handleBlur, className: errors.email ? "input-error" : "", placeholder: "Enter your email" }), errors.email && _jsx(MdError, { className: "error-icon" })] }), errors.email && (_jsx("span", { className: "error-message", children: errors.email }))] }), _jsxs("div", { className: "form-group password-input-container", children: [_jsx("label", { htmlFor: "password", children: "Password" }), _jsxs("div", { className: "input-wrapper", children: [_jsx("input", { type: showPassword ? "text" : "password", id: "password", name: "password", value: formData.password, onChange: handleChange, onBlur: handleBlur, className: errors.password ? "input-error" : "", placeholder: "Enter your password" }), _jsx("button", { type: "button", className: "password-toggle", onClick: togglePasswordVisibility, "aria-label": showPassword ? "Hide password" : "Show password", children: showPassword ? _jsx(FaEyeSlash, {}) : _jsx(FaEye, {}) })] }), errors.password && (_jsx("span", { className: "error-message", children: errors.password }))] }), _jsx("div", { className: "form-options", children: _jsxs("label", { className: "remember-me", children: [_jsx("input", { type: "checkbox" }), "Remember me"] }) }), _jsx("button", { type: "submit", className: "login-button", children: "Sign In" }), authError && _jsx("p", { className: "error-message", children: authError })] }), _jsxs("div", { className: "signup-link", children: ["Don't have an account? ", _jsx(Link, { to: "/register", children: "Sign up" })] })] }) }) }));
};
export default Login;
